import { render, staticRenderFns } from "./EmailAddressChange.vue?vue&type=template&id=1a151f27&scoped=true&"
import script from "./EmailAddressChange.vue?vue&type=script&lang=js&"
export * from "./EmailAddressChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a151f27",
  null
  
)

export default component.exports